import {
    AMOUNT_DISPLAY_DECIMALS,
    AMOUNT_DISPLAY_MIN_THRESHOLD,
} from '../constant/constant';

export function parseAmountValue(value) {
    if (value === null || value === undefined || value === '') return NaN;
    if (typeof value === 'number') return value;
    const cleaned = String(value).replace(/,/g, '').trim();
    if (cleaned.startsWith('<')) return NaN;
    const n = Number(cleaned);
    return n;
}

export function formatThresholdLabel() {
    return Number(AMOUNT_DISPLAY_MIN_THRESHOLD).toLocaleString('en-US', {
        minimumFractionDigits: AMOUNT_DISPLAY_DECIMALS,
        maximumFractionDigits: AMOUNT_DISPLAY_DECIMALS,
    });
}

/** Full-precision string for tooltips (no "< …" abbreviation). */
export function formatAmountFull(value) {
    const n = parseAmountValue(value);
    if (!Number.isFinite(n)) return '—';
    if (n === 0) return '0';
    return n.toLocaleString('en-US', {
        maximumFractionDigits: 18,
        useGrouping: true,
    });
}

/** Compact display amount for tables, cards, and labels. */
export function formatNumber(value) {
    const n = parseAmountValue(value);
    if (!Number.isFinite(n)) return '—';
    if (n === 0) return '0';

    const abs = Math.abs(n);
    if (abs > 0 && abs < AMOUNT_DISPLAY_MIN_THRESHOLD) {
        return `< ${formatThresholdLabel()}`;
    }

    const isInteger = Number.isInteger(n);
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: isInteger ? 0 : 0,
        maximumFractionDigits: AMOUNT_DISPLAY_DECIMALS,
    }).format(n);
}

export function needsAmountTooltip(value) {
    const n = parseAmountValue(value);
    if (!Number.isFinite(n) || n === 0) return false;

    const abs = Math.abs(n);
    if (abs > 0 && abs < AMOUNT_DISPLAY_MIN_THRESHOLD) return true;

    const rounded = Number(n.toFixed(AMOUNT_DISPLAY_DECIMALS));
    return Math.abs(n - rounded) > 1e-12;
}
